import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { DashboardModule } from '../dashboard/dashboard.module'
import { DistributionsModule } from '../distributions/distributions.module'
import { FundLiteratureModule } from '../fund-literature/fund-literature.module'
import { FundManagementModule } from '../fund-management/fund-management.module'
import { OverviewModule } from '../overview/overview.module'
import { PerformanceModule } from '../performance/performance.module'
import { PortfolioModule } from '../portfolio/portfolio.module'
import { PriceModule } from '../price/price.module'
import { ProxyVotingModule } from '../proxy-voting/proxy-voting.module'
import { ConstellationModule } from '../shared/constellation.module'
import { NavTabGroupComponent } from './nav-tab-group.component'

@NgModule({
  declarations: [NavTabGroupComponent],
  imports: [
    CommonModule,
    OverviewModule,
    PerformanceModule,
    PortfolioModule,
    PriceModule,
    DistributionsModule,
    FundLiteratureModule,
    FundManagementModule,
    ProxyVotingModule,
    DashboardModule,
    ConstellationModule,
  ],
  exports: [NavTabGroupComponent],
})
export class NavTabGroupModule {}
